import obj from './obj.js';
import { State } from './product-state.js';

export const matchCartItem = (
  productId: [string, string],
  projectId: [string, string],
  props: [State, State],
) =>
  productId[0] === productId[1] &&
  projectId[0] === projectId[1] &&
  obj.compare.shallow(props[0], props[1]);
